import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-dashboard-turns-requests-activity-zoom-card',
  templateUrl: './dashboard-turns-requests-activity-zoom-card.component.html',
  styleUrls: ['./dashboard-turns-requests-activity-zoom-card.component.scss']
})
export class DashboardTurnsRequestsActivityZoomCardComponent implements OnInit, AfterViewInit {

  @ViewChild('requestsActivity', { static: false }) requestsActivityRef: ElementRef;
  ctx;
  myChart;
  title;
  colors;
  selectedMode;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<MatDialog>) { }

  ngOnInit() {
    this.title = this.data.title;
    this.colors = this.data.colors;
    this.selectedMode = this.data.selectedMode;
  }

  ngAfterViewInit() {
    this.ctx = this.requestsActivityRef.nativeElement.getContext('2d');
    this.render();
  }

  public modeSelectedChange(e) {
    this.render();
  }

  public close() {
    this.dialogRef.close();
  }

  public render() {
    switch (this.selectedMode) {
      case 'perType':
        this.renderPerTypeChart(this.data.data);
        break;
      case 'perDesk':
        this.renderPerDeskChart(this.data.data);
        break;
    }
  }

  private renderPerTypeChart(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const dataSets = new Array();
    data.forEach((media, i) => {
      dataSets.push({
        label: media.label,
        data: media.count,
        borderColor: this.colors[i],
        pointBorderColor: this.colors[i],
        pointBackgroundColor: '#ffffff',
        fill: false,
        borderWidth: 2,
        lineTension: 0.00
      });
    });
    this.ctx = this.requestsActivityRef.nativeElement.getContext('2d');
    this.myChart = new Chart(this.ctx, {
      type: 'line',
      data: {
        datasets: dataSets,
        labels: ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa',
          labels: {
            padding: 15,
            boxWidth: 20,
            fontColor: '#aaaaaa'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              padding: 20,
              fontColor: '#aaaaaa'
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#aaaaaa'
            }
          }]
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if ((dataSets && !(dataSets.length > 0))) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }

  private renderPerDeskChart(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const dataSets = new Array();
    data.forEach((desk, i) => {
      dataSets.push({
        label: desk.deskName,
        data: desk.count,
        borderColor: this.colors[i],
        fill: false,
        borderWidth: 2,
        lineTension: 0.00
      });
    });
    this.ctx = this.requestsActivityRef.nativeElement.getContext('2d');
    this.myChart = new Chart(this.ctx, {
      type: 'line',
      data: {
        datasets: dataSets,
        labels: ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa',
          labels: {
            padding: 15,
            boxWidth: 20,
            fontColor: '#aaaaaa'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              padding: 20,
              fontColor: '#aaaaaa'
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#aaaaaa'
            }
          }]
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if (data.length === 0) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }
}
